import React from 'react';
import { Modal, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import SymbolAvgVoltage from './SymbolAvgVoltage';
import "./Svg.css";

function signed32(v) {
    if (v == null || v === '') return null;
    let n = parseInt(v);
    if (isNaN(n)) return null;
    if (n > 0x7fffffff) {
        n = n - 0x100000000;
    }
    return n;
}

function signed16(v) {
    if (v == null || v === '') return null;
    let n = parseInt(v);
    if (isNaN(n)) return null;
    if (n > 0x7fff) {
        n = n - 0x10000;
    }
    return n;
}

function SvgGridLoad({x, y, Combinations }) {
    const { t } = useTranslation();

    let PAC = 0;
    let QAC = 0;
    let VAC = 0;
    let IAC = 0;
    let vCount = 0;
    let rows = [];

    if (Combinations != null) {
        Combinations.forEach((item) => {
            let p = "";
            let q = "";
            let volt = "";
            let i = "";
            const sp = signed32(item.PAC1GridLoad);
            if (sp != null) {
                PAC += sp * 0.001;
                p = (sp * 0.001).toFixed(3);
            }
            const sq = signed32(item.QAC1GridLoad);
            if (sq != null) {
                QAC += sq * 0.001;
                q = (sq * 0.001).toFixed(3);
            }
            if (item.VAC1GridLoad != null) {
                VAC += parseInt(item.VAC1GridLoad) * 0.1;
                vCount++;
                volt = (parseInt(item.VAC1GridLoad) * 0.1).toFixed(1);
            }
            const si = signed16(item.IAC1GridLoad);
            if (si != null) {
                IAC += si * 0.1;
                i = (si * 0.1).toFixed(1);
            }
            rows.push({
                SN: item.SN,
                CreateTime: item.CreateTime,
                Phase: item.InverterConnectionMode,
                PAC1GridLoad: p,
                QAC1GridLoad: q,
                VAC1GridLoad: volt,
                IAC1GridLoad: i,
            });
        });
    }

    const handleClick = () => {
        Modal.info({
            maskClosable: true,
            width: "80%",
            icon: null,
            title: t("Grid-Side Load Data"),
            content: (<Table
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase === 2 ? "(A)" : r.Phase === 3 ? "(B)" : r.Phase === 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("PAC1GridLoad")+"(kW)", dataIndex: "PAC1GridLoad",  align: "right" },
                    { title: t("QAC1GridLoad")+"(kW)", dataIndex: "QAC1GridLoad",  align: "right" },
                    { title: t("VAC1GridLoad")+"(V)", dataIndex: "VAC1GridLoad",  align: "right" },
                    { title: t("IAC1GridLoad")+"(A)", dataIndex: "IAC1GridLoad",  align: "right" },
                ]}
                dataSource={rows}
                scroll={{ x: true }}
            />),
            onOk() {
            },
        });
    };

    let count = Combinations?.length || 0;
    const avgV = (vCount > 0 ? VAC / vCount : 0).toFixed(1);
    const textW = 220;

    return (<svg xmlns="http://www.w3.org/2000/svg">
        <SymbolAvgVoltage id="VoltageAvg-GridLoad"/>
        <svg cursor={"pointer"} x={x} y={y} width={84} height={84}  version="1.1"  viewBox="0 0 83.13 73.76"
            onClick={handleClick}
        >
            <defs>
                <style>{`.cls-1{fill:#1d80b5;}.cls-2{fill:#fff;}`}</style>
            </defs>
            <rect x="0" y="0" width="83.13" height="73.76" fill="#fff" stroke="none" />
            <g>
                <g>
                    <path className="cls-1" d="M58.17-7.13h4.71a.52.52,0,0,1,.52.52V49.25a0,0,0,0,1,0,0H57.65a0,0,0,0,1,0,0V-6.61a.52.52,0,0,1,.52-.52Z" transform="translate(116.79 -9.63) rotate(132.2)" />
                    <path className="cls-1" d="M19.73-7.09h5.75a0,0,0,0,1,0,0V48.77a.52.52,0,0,1-.52.52H20.25a.52.52,0,0,1-.52-.52V-7.09A0,0,0,0,1,19.73-7.09Z" transform="translate(23.05 -9.82) rotate(47.8)" />
                    <path className="cls-1" d="M70.77,73.76H12.38a1.5,1.5,0,0,1-1.49-1.5l0-33.54L41.17,11.1,72.24,38.72l0,33.54A1.5,1.5,0,0,1,70.77,73.76Z" />
                    <rect className="cls-1" x="61.38" y="8.62" width="12.47" height="3.05" rx="0.4" />
                    <polygon className="cls-1" points="62.82 10.95 72.42 10.95 72.37 24.14 62.82 15.89 62.82 10.95" />
                    <path className="cls-2" d="M42.39,54.72c-2.5,0-6.85.05-8.83.06-.08,0,0-.15,0-.33,0-.37-.15-.93-.3-1-3.68-2.32-6.7-7.12-6.7-11.35A14.68,14.68,0,0,1,33,30.48,16.76,16.76,0,0,1,42,28" />
                    <path className="cls-2" d="M40.75,54.71c2.5,0,6.85,0,8.83.06.08,0,0-.15,0-.33,0-.37.15-.93.3-1,3.68-2.32,6.7-7.12,6.7-11.35a14.7,14.7,0,0,0-6.47-11.59,16.76,16.76,0,0,0-9-2.47" />
                    <path className="cls-2" d="M33.49,57.46H49.65a0,0,0,0,1,0,0v2.46a3.52,3.52,0,0,1-3.52,3.52H37a3.52,3.52,0,0,1-3.52-3.52V57.46A0,0,0,0,1,33.49,57.46Z" />
                    <rect className="cls-2" x="35.82" y="65.13" width="11.51" height="2.34" rx="0.9" />
                    <polygon className="cls-1" points="39.16 51.26 48.78 39.38 41.56 39.38 41.56 30.47 34.34 42.35 41.56 42.35 39.16 51.26" />
                </g>
            </g>
            {count > 1 ?
                <svg x ={84 - 32} y={84 - 32} width="32" height="32" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="46" stroke="#eee" strokeWidth="8" fill="#1d80b5" />
                    <text x="50" y="53" fontSize="46px" fill="white" fontWeight="bold" textAnchor="middle" alignmentBaseline="middle">∑</text>
                </svg>
                : null
            }
        </svg>
        <svg x={x - textW - 8} y={y} width={textW} cursor={"pointer"} onClick={handleClick}>
            <text x={textW} y={16} fontSize="16" fill="black" textAnchor="end">{t("Grid-Side Load")}</text>
            <text x={textW} y={34} fontSize="16" fill="black" textAnchor="end">
                {PAC.toFixed(3)} kW
                {count>1 && <tspan dy="-1.2em" className='sigma'>(Σ{count})</tspan>}
            </text>
            <text x={textW} y={52} fontSize="16" fill="black" textAnchor="end">{QAC.toFixed(3)} kW</text>
            <text x={textW - (count>1 ? 0 : 16)} y={70} fontSize="16" fill="black" textAnchor="end">{avgV}</text>
            {count<2 && <text x={textW} y={70} fontSize="16" fill="black" textAnchor="end">V</text>}
            {count>1 && <use href="#VoltageAvg-GridLoad" x={textW - 20} y={54} fontSize="16" width="20" height="16" />}
            <text x={textW} y={88} fontSize="16" fill="black" textAnchor="end">{IAC.toFixed(1)} A</text>
        </svg>
    </svg>)
}

export default SvgGridLoad
